import { requestTranslation } from "./translatorClient";
import { splitMixedTamilWord, getTanglishForMixedWord } from "./tamilPhonetics";

const translationCache = new Map();

export const CITY_TAMIL_DICTIONARY = {
  "abiramam": "அபிராமம்",
  "acharapakkam": "அச்சரப்பாக்கம்",
  "adirampattinam": "அதிராம்பட்டினம்",
  "agastheeswaram": "அகஸ்தீஸ்வரம்",
  "alangayam": "ஆலங்காயம்",
  "alangudi": "ஆலங்குடி",
  "alangulam": "ஆலங்குளம்",
  "alandur": "ஆலந்தூர்",
  "alavakottai": "ஆலவக்கோட்டை",
  "amalapuram": "அமலாபுரம்",
  "ambasamudram": "அம்பாசமுத்திரம்",
  "ambattur": "அம்பத்தூர்",
  "ambur": "ஆம்பூர்",
  "ammapet": "அммаப்பேட்டை",
  "anaimalai": "ஆனைமலை",
  "anaikatti": "ஆனைகட்டி",
  "anakaputhur": "அனகாபுத்தூர்",
  "andipatti": "ஆண்டிபட்டி",
  "arani": "ஆரணி",
  "arcot": "ஆற்காடு",
  "ariyalur": "அரியலூர்",
  "arkonam": "அரக்கோணம்",
  "arni": "ஆரணி",
  "arulmigu palaniandavar": "அருள்மிகு பழனியாண்டவர்",
  "aruppukkottai": "அருப்புக்கோட்டை",
  "attur": "ஆத்தூர்",
  "avadi": "ஆவடி",
  "avanashi": "அவிநாசி",
  "ayakudi": "ஆயக்குடி",
  "batlagundu": "வத்தலகுண்டு",
  "bhavani": "பவானி",
  "bhuvanagiri": "புவனகிரி",
  "chengalpattu": "செங்கல்பட்டு",
  "chengam": "செங்கம்",
  "chennai": "சென்னை",
  "chidambaram": "சிதம்பரம்",
  "chinnamanur": "சின்னமனூர்",
  "chinnasekkadu": "சின்னசேக்காடு",
  "coimbatore": "கோயம்புத்தூர்",
  "coonoor": "குன்னூர்",
  "cuddalore": "கடலூர்",
  "denkanikottai": "தேன்கனிக்கோட்டை",
  "devakottai": "தேவகோட்டை",
  "dharapuram": "தாராபுரம்",
  "dharmapuri": "தருமபுரி",
  "dindigul": "திண்டுக்கல்",
  "edappadi": "இடப்பாடி",
  "erode": "ஈரோடு",
  "ettayapuram": "எட்டயபுரம்",
  "gandarvakottai": "கந்தர்வகோட்டை",
  "gingee": "செஞ்சி",
  "gobichettipalayam": "கோபிசெட்டிபாளையம்",
  "gudalur": "கூடலூர்",
  "gudiyatham": "குடியாத்தம்",
  "harur": "அரூர்",
  "hosur": "ஓசூர்",
  "ilayangudi": "இளையான்குடி",
  "injambakkam": "இஞ்சம்பாக்கம்",
  "jalakandapuram": "ஜலகண்டாபுரம்",
  "jayamkondam": "ஜெயங்கொண்டம்",
  "kallakurichi": "கள்ளக்குறிச்சி",
  "kalpakkam": "கல்பாக்கம்",
  "kancheepuram": "காஞ்சிபுரம்",
  "kangayam": "காங்கேயம்",
  "karaikal": "காரைக்கால்",
  "karaikudi": "காரைக்குடி",
  "karamadai": "காரமடை",
  "kariapatti": "கரியாப்பட்டி",
  "karur": "கரூர்",
  "kayalpattinam": "காயல்பட்டினம்",
  "kilvelur": "கீழ்வேளூர்",
  "kodaikanal": "கொடைக்கானல்",
  "kodumudi": "கொடுமுடி",
  "kolathur": "கொளத்தூர்",
  "komarapalayam": "குமாரபாளையம்",
  "kotagiri": "கோத்தகிரி",
  "kovilpatti": "கோவில்பட்டி",
  "krishnagiri": "கிருஷ்ணகிரி",
  "kulasekharapatnam": "குலசேகரபட்டினம்",
  "kumbakonam": "கும்பகோணம்",
  "kunnam": "குன்னம்",
  "kurinjipadi": "குறிஞ்சிப்பாடி",
  "lalgudi": "லால்குடி",
  "madurai": "மதுரை",
  "madurantakam": "மதுராந்தகம்",
  "manapparai": "மணப்பாறை",
  "mannargudi": "மன்னார்குடி",
  "maraimalai nagar": "மறைமலைநகர்",
  "marthandam": "மார்த்தாண்டம்",
  "mayiladuthurai": "மயிலாடுதுறை",
  "melur": "மேலூர்",
  "mettupalayam": "மேட்டுப்பாளையம்",
  "mettur": "மேட்டூர்",
  "mudukulathur": "முதுகுளத்தூர்",
  "musiri": "முசிறி",
  "nagapattinam": "நாகப்பட்டினம்",
  "nagercoil": "நாகர்கோவில்",
  "namakkal": "நாமக்கல்",
  "nandambakkam": "நந்தம்பாக்கம்",
  "nanguneri": "நாங்குநேரி",
  "natham": "நத்தம்",
  "neyveli": "நெய்வேலி",
  "nilakkottai": "நிலக்கோட்டை",
  "oddanchatram": "ஒட்டன்சத்திரம்",
  "ooty": "ஊட்டி",
  "padmanabhapuram": "பத்மநாபபுரம்",
  "palani": "பழனி",
  "palayamkottai": "பாளையங்கோட்டை",
  "palladam": "பல்லடம்",
  "papanasam": "பாபநாசம்",
  "paramakudi": "பரமக்குடி",
  "parangipettai": "பரங்கிப்பேட்டை",
  "pattukkottai": "பட்டுக்கோட்டை",
  "pennadam": "பெண்ணாடம்",
  "pennagaram": "பெண்ணாகரம்",
  "perambalur": "பெரம்பலூர்",
  "periyakulam": "பெரியகுளம்",
  "perundurai": "பெருந்துறை",
  "pollachi": "பொள்ளாச்சி",
  "polur": "போளூர்",
  "ponneri": "பொன்னேரி",
  "pudukkottai": "புதுக்கோட்டை",
  "puliyankudi": "புளியங்குடி",
  "rajapalayam": "ராஜபாளையம்",
  "ramanathapuram": "இராமநாதபுரம்",
  "ranipet": "ராணிப்பேட்டை",
  "rasipuram": "ராசிபுரம்",
  "salem": "சேலம்",
  "sankarankovil": "சங்கரன்கோவில்",
  "sankari": "சங்ககிரி",
  "sattur": "சாத்தூர்",
  "sendurai": "செந்துறை",
  "sholinghur": "சோளிங்கர்",
  "sivagangai": "சிவகங்கை",
  "sivagiri": "சிவகிரி",
  "sivakasi": "சிவகாசி",
  "sriperumbudur": "ஸ்ரீபெரும்புதூர்",
  "srirangam": "ஸ்ரீரங்கம்",
  "tambaram": "தாம்பரம்",
  "tenkasi": "தென்காசி",
  "thanjavur": "தஞ்சாவூர்",
  "theni": "தேனி",
  "thirumangalam": "திருமங்கலம்",
  "thiruthuraipoondi": "திருத்துறைப்பூண்டி",
  "thiruvananthapuram": "திருவனந்தபுரம்",
  "thiruvottiyur": "திருவொற்றியூர்",
  "thoothukudi": "தூத்துக்குடி",
  "tindivanam": "திண்டிவனம்",
  "tirukalukundram": "திருக்கழுக்குன்றம்",
  "tirukkoyilur": "திருக்கோவிலூர்",
  "tirunelveli": "திருநெல்வேலி",
  "tirupathur": "திருப்பத்தூர்",
  "tiruppur": "திருப்பூர்",
  "tiruchendur": "திருச்செந்தூர்",
  "tiruchengode": "திருச்செங்கோடு",
  "tiruchirappalli": "திருச்சிராப்பள்ளி",
  "tirumullaivoyal": "திருமுல்லைவாயில்",
  "tirupur": "திருப்பூர்",
  "tiruvallur": "திருவள்ளூர்",
  "tiruvannamalai": "திருவண்ணாமலை",
  "tiruvaru": "திருவாரூர்",
  "udumalpet": "உடுமலைப்பேட்டை",
  "ulundurpettai": "உளுந்தூர்ப்பேட்டை",
  "usilampatti": "உசிலம்பட்டி",
  "uthangarai": "உத்தங்கரை",
  "uttiramerur": "உத்திரமேரூர்",
  "valapady": "வாழப்பாடி",
  "vandavasi": "வந்தவாசி",
  "vaniyambadi": "வாணியம்பாடி",
  "vellore": "வேலூர்",
  "velur": "வேளூர்",
  "vikramasingapuram": "விக்கிரமசிங்கபுரம்",
  "virudhachalam": "விருத்தாசலம்",
  "virudhunagar": "விருதுநகர்",
  "walajabad": "வாலாஜாபாத்",
  "walajapet": "வாலாஜாப்பேட்டை",
  "yercaud": "ஏற்காடு"
};

/**
 * Transliterate English text to Tamil
 * Results are cached to avoid repeated API calls
 */
export const translateToTamil = async (text) => {
  if (!text) return null;

  const normalized = text.toLowerCase().trim();
  if (CITY_TAMIL_DICTIONARY[normalized]) {
    return CITY_TAMIL_DICTIONARY[normalized];
  }

  const cacheKey = `en-ta:${text}`;
  if (translationCache.has(cacheKey)) {
    return translationCache.get(cacheKey);
  }

  const mixed = splitMixedTamilWord(text.trim());
  if (mixed) {
    const { leadingNonTamil, tamilPrefix, englishSuffix } = mixed;
    const tanglishWord = getTanglishForMixedWord(tamilPrefix, englishSuffix);
    try {
      const res = await requestTranslation(
        { text: tanglishWord, source: "en", target: "ta", mode: "transliterate" },
        { headers: { "Content-Type": "application/json" } }
      );
      const suggestions = Array.isArray(res.data?.suggestions) ? res.data.suggestions : [];
      const match = suggestions.find((s) => s.startsWith(tamilPrefix)) || res.data?.translated;
      if (match) {
        const result = (leadingNonTamil || "") + match;
        translationCache.set(cacheKey, result);
        return result;
      }
    } catch (e) {}
  }

  try {
    const res = await requestTranslation(
      { text, source: "en", target: "ta", mode: "transliterate" },
      { headers: { "Content-Type": "application/json" } }
    );

    const translated =
      (Array.isArray(res.data.suggestions) && res.data.suggestions[0]) ||
      res.data.translated;

    if (translated && translated !== text) {
      translationCache.set(cacheKey, translated);
      return translated;
    }
  } catch (error) {
    console.error("Translation error:", error);
  }

  return null;
};

/**
 * Translate Tamil text to English (reverse transliteration)
 */
export const translateFromTamil = async (text) => {
  if (!text) return null;

  const cacheKey = `ta-en:${text}`;
  if (translationCache.has(cacheKey)) {
    return translationCache.get(cacheKey);
  }

  try {
    const res = await requestTranslation(
      { text, source: "ta", target: "en", mode: "transliterate" },
      { headers: { "Content-Type": "application/json" } }
    );

    const translated =
      (Array.isArray(res.data.suggestions) && res.data.suggestions[0]) ||
      res.data.translated;

    if (translated) {
      translationCache.set(cacheKey, translated);
      return translated;
    }
  } catch (error) {
    console.error("Translation error:", error);
  }

  return null;
};

/**
 * Checks whether text starts with query, either at the beginning of the string
 * or at any word boundary (e.g. "Maraimalai Nagar" matches "nagar" or "marai").
 * Does NOT match center/interior letters of words.
 *
 * @param {string} text - The candidate text (e.g. city name)
 * @param {string} query - The search query
 * @returns {boolean}
 */
export const matchesStartOfWord = (text, query) => {
  if (!text || !query) return false;
  const cleanText = text.toLowerCase().trim();
  const cleanQuery = query.toLowerCase().trim();
  if (!cleanQuery) return true;

  // 1. Direct prefix match from start of string
  if (cleanText.startsWith(cleanQuery)) {
    return true;
  }

  // 2. Prefix match on word boundaries (e.g. "Maraimalai Nagar" -> "nagar")
  const words = cleanText.split(/[\s,/-]+/);
  return words.some((word) => word.startsWith(cleanQuery));
};

/**
 * Filter cities supporting both English and Tamil search starting from the word's beginning.
 * Center/interior letters are strictly excluded.
 *
 * @param {Array} cities - Array of city names in English
 * @param {string} query - Search query (can be English or Tamil)
 * @param {Map} tamilCache - Map to store Tamil translations
 * @param {number} limit - Maximum number of results
 * @returns {Promise<Array>} - Filtered cities up to limit
 */
export const filterCitiesWithTamilSupport = async (
  cities,
  query,
  tamilCache,
  limit = 25
) => {
  if (!query || query.trim().length === 0) {
    return cities.slice(0, limit);
  }

  const searchLower = query.toLowerCase().trim();
  const isTamilInput = /[\u0B80-\u0BFF]/.test(query);
  const hasEnglish = /[a-zA-Z]/.test(query);

  const results = [];
  let tamilQuery = null;

  if (hasEnglish) {
    const hasTamilCities = cities.some((city) => /[\u0B80-\u0BFF]/.test(city));
    if (hasTamilCities) {
      tamilQuery = await translateToTamil(query);
      tamilQuery = tamilQuery ? tamilQuery.toLowerCase().trim() : null;
    }
  }

  for (const city of cities) {
    if (results.length >= limit) break;

    const cityText = String(city);
    const cityLower = cityText.toLowerCase();
    const cityHasTamil = /[\u0B80-\u0BFF]/.test(cityText);

    // 1. Direct match from start of word (English/Latin or raw string)
    if (matchesStartOfWord(cityLower, searchLower)) {
      results.push(cityText);
      continue;
    }

    // 2. English query against Tamil city text (from start of word)
    if (!isTamilInput && tamilQuery && cityHasTamil) {
      if (matchesStartOfWord(cityLower, tamilQuery)) {
        results.push(cityText);
      }
      continue;
    }

    // 3. Tamil input against English city translated to Tamil (from start of word)
    if (isTamilInput && !cityHasTamil) {
      let cityTamil = tamilCache?.get ? tamilCache.get(cityText) : null;
      if (!cityTamil) {
        cityTamil =
          CITY_TAMIL_DICTIONARY[cityLower] || (await translateToTamil(cityText));
        if (cityTamil && tamilCache?.set) {
          tamilCache.set(cityText, cityTamil);
        }
      }
      if (cityTamil && matchesStartOfWord(cityTamil, searchLower)) {
        results.push(cityText);
      }
    }
  }

  return results.slice(0, limit);
};


/**
 * Clear the translation cache (useful for testing)
 */
export const clearTranslationCache = () => {
  translationCache.clear();
};

/**
 * Get cached translation or fetch it
 */
export const getCachedOrFetchTamil = async (text, tamilCache) => {
  if (tamilCache.has(text)) {
    return tamilCache.get(text);
  }

  const tamil = await translateToTamil(text);
  if (tamil) {
    tamilCache.set(text, tamil);
  }
  return tamil;
};
